import { Button, Modal } from 'antd';
import * as React from 'react';

interface ILocalProps {
    message: string,
    onCancel: () => void,
    onConfirm: () => void,
    title: string,
}

const ConfirmationModal: React.SFC<ILocalProps> = (props: ILocalProps): JSX.Element => {
    return (
        <Modal
            closable={false}
            title={props.title}
            visible={true}
            className="modal"
            footer={[
                <Button key="close" onClick={props.onCancel} style={{ float: 'left' }}>No</Button>,
                <Button key="submit" onClick={props.onConfirm} type="primary">Yes</Button>,
            ]}
        >
            <div>
                {props.message}
            </div>
        </Modal>
    );
}

export default ConfirmationModal;
